import React from 'react';
import ReactDOM from 'react-dom/client';
import RageRoomDirectory from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RageRoomDirectory />
  </React.StrictMode>
);
